import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Circulation, CirculationId, EntityId } from "src/app/interfaces";

export const loadCirculations = createAction(
  "[Circulation/API] Load Circulations"
);

export const loadCirculationsSuccess = createAction(
  "[Circulation/API] Load Circulations Success",
  props<{ circulations: Circulation[] }>()
);

export const loadCirculationsFailure = createAction(
  "[Circulation/API] Load Circulations Fail",
  props<{ error: HttpErrorResponse }>()
);

export const loadCirculation = createAction(
  "[Circulation/API] Load Circulation",
  props<{ id: CirculationId }>()
);

export const loadCirculationSuccess = createAction(
  "[Circulation/API] Load Circulation Success",
  props<{ circulation: Circulation }>()
);

export const loadCirculationFailure = createAction(
  "[Circulation/API] Load Circulation Fail",
  props<{ error: HttpErrorResponse }>()
);

export const saveCirculation = createAction(
  "[Circulation/API] Save Circulation",
  props<{ circulation: Circulation }>()
);

export const saveCirculationSuccess = createAction(
  "[Circulation/API] Save Circulation success",
  props<{ id: CirculationId }>()
);

export const saveCirculationFailure = createAction(
  "[Circulation/API] Save Circulation Fail",
  props<{ error: HttpErrorResponse }>()
);

export const copyCirculation = createAction(
  "[Circulation/API] Copy Circulation",
  props<{ circId: EntityId }>()
);

export const copyCirculationSuccess = createAction(
  "[Circulation/API] Copy Circulation success",
  props<{ id: CirculationId }>()
);

export const copyCirculationFailure = createAction(
  "[Circulation/API] Copy Circulation Fail",
  props<{ error: string }>()
);
